import { useTranslation } from '@conekta/cronos/i18n';
import { PluginsContext } from 'app/features/plugins/state/pluginsContext';
import { ConektaSource } from 'app/sdk/embedded/EmbeddedConfig';
import { useContext, useState } from 'react';

import { COMPONENT_CONTAINER_IDENTIFIER, defaultComponentOptions } from '../constants';
import { IEvent, ViewState } from '../interface';
import { onEventListener } from '../views/Checkout';
import { CheckoutFrameContext } from 'app/context';

const useIframe = (state: ViewState) => {
  const { setIsFinalizedPayment } = useContext(PluginsContext);
  const { setPlan } = useContext(CheckoutFrameContext);
  const { checkoutRequest, keys, isIntegration, configuration = {}, comesFromWebhook, orderId, chargeId } = state;
  const { i18n, t } = useTranslation();
  const [contentLoaded, setContentLoaded] = useState(!orderId && !comesFromWebhook && !chargeId);

  const initIframe = () => {
    const buttonText = t('iFrame.checkout.buttonSubmitFinalize');
    const config = {
      targetIFrame: `${COMPONENT_CONTAINER_IDENTIFIER}`,
      checkoutRequestId: checkoutRequest.id,
      publicKey: keys.publicKey,
      isIntegration,
      locale: i18n.language,
      customStyle: configuration.customStyleJSON,
      options: {
        orderId,
        liveMode: comesFromWebhook,
        chargeId,
        customStyle: configuration.customStyleJSON,
      },
    };
    const onGetInfoSuccess = () => {
      setContentLoaded(true);
    };
    const onFinalizePayment = () => {
      setIsFinalizedPayment(true);
    };
    const callbacks: any = {
      onEventListener: (event: IEvent) => {
        if (event.name === 'plan' && event.value) {
          setPlan(event.value);
        }

        onEventListener(event, t);
      },
      onGetInfoSuccess,
      onFinalizePayment,
    };
    const options = buildComponentOptions(configuration, buttonText);

    window.ConektaCheckoutComponents.SelfHosted({
      config,
      isSelfHosted: true,
      preloadedState: state,
      callbacks,
      options: { ...options, customStyle: configuration.customStyleJSON },
      conektaSource: checkoutRequest.type === 'PaymentLink' ? ConektaSource.PAYMENT_LINK : ConektaSource.REDIRECTED,
    });
  };

  return {
    initIframe,
    contentLoaded,
  };
};

export default useIframe;

const getDefaultTextColor = (styles: any) =>
  styles?.letters?.paymentMethods?.color ?? defaultComponentOptions.colorText;

const getThemeConfig = (styles: any) => {
  const textColor = getDefaultTextColor(styles);
  return {
    colorPrimary: styles?.colors?.primary ?? defaultComponentOptions.colorPrimary,
    colorText: styles?.colors?.textColor ?? textColor,
    colorLabel: styles?.colors?.labelColor ?? textColor,
    inputType: styles?.inputType ?? defaultComponentOptions.inputType,
    backgroundMode: styles?.backgroundMode ?? defaultComponentOptions.backgroundMode,
  };
};

const buildComponentOptions = (configuration: Record<string, any>, buttonText: string) => {
  const themeConfig = configuration.customStyleJSON ? getThemeConfig(configuration.customStyleJSON.styles) : {};
  return {
    ...themeConfig,
    button: {
      text: buttonText,
      buttonPayText: buttonText,
    },
  };
};
